function handleShiftEnterSubmit(event, text, submitHandler) {
  if (event.shiftKey && event.key === "Enter") {
    event.preventDefault()
    const trimmedText = text.trim()
    if (trimmedText.length > 0) {
      submitHandler(trimmedText)
    }
  }
}

export { handleShiftEnterSubmit } 